<template>
  <add-or-update pageType="update"></add-or-update>
</template>

<script>
import addOrUpdate from "./components/addOrUpdate";
export default {
  name: "driversManageUpdate",
  components: {
    addOrUpdate
  }
};
</script>
